import { jsx as _jsx } from "react/jsx-runtime";
import LazyLoad from '../lazyload';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var cls = 'block';

var Block = function Block(_ref) {
  var config = _ref.config,
      onClick = _ref.onClick,
      id = _ref.id,
      className = _ref.className,
      pid = _ref.pid,
      render = _ref.render;
  var href = config.href,
      link = config.link,
      deepLink = config.deepLink;

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls;

  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);

  var clickHandler = function clickHandler() {
    onClick === null || onClick === void 0 ? void 0 : onClick({
      render: render,
      deeplink: deepLink,
      link: link,
      componentId: id,
      pid: pid
    });
  };

  return _jsx("div", Object.assign({
    className: classes,
    onClick: clickHandler,
    "data-componentid": id,
    "data-pid": pid
  }, {
    children: _jsx(LazyLoad, Object.assign({
      height: 200
    }, {
      children: _jsx("object", {
        className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-section", prefixCls)),
        data: href,
        type: "image/svg+xml"
      })
    }))
  }));
};

Block.displayName = 'Block';
Block.defaultProps = {
  config: {}
};
export default Block;